/*
 * @Author: wupeiwen <javapeiwen2010@gmail.com>
 * @Date: 2022-03-21 11:34:22
 * @LastEditors: wupeiwen <javapeiwen2010@gmail.com>
 * @LastEditTime: 2022-06-14 22:11:29
 * @FilePath: /jy-dashboard-web/src/main.js
 * @Description: 主入口文件
 */
import { createApp } from 'vue'
import App from '@/App.vue'
import registerComponents from '@/util/registerComponents'
import router from '@/util/router'
import store from '@/util/store'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import '@/assets/style/global.scss'
import vueSeamlessScroll from '@zengxiaohui/vue3-seamless-scroll'

const app = createApp(App)
registerComponents(app)
app.use(store)
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.use(vueSeamlessScroll)
app.mount('#app')
